import { messageToHtml } from "../editor/serialization";
import { TemplateHtmlPreview } from "./TemplateHtmlPreview";
import { TemplateRichTextPreview } from "./TemplateRichTextPreview";
import type { TemplateEditorMode } from "./types";

export interface TemplateBodyPreviewProps {
  html?: string;
  message?: string;
  mode?: TemplateEditorMode;
  className?: string;
}

export const TemplateBodyPreview = ({ html, message, mode, className }: TemplateBodyPreviewProps) => {
  const body = html || messageToHtml(message ?? "");

  return mode === "html" ? (
    <TemplateHtmlPreview html={body} className={className} />
  ) : (
    <TemplateRichTextPreview html={body} className={className} />
  );
};
